// ui/src/pages/calendar/CalendarRoute.tsx
//
// Role branch for the shared /calendar path — same pattern
// DashboardOrParent already uses for /dashboard: one route registered in
// App.tsx, the component picks which page to render off the loaded user's
// active role rather than a distinct URL per role. STAFF get the read-only
// scoped view (Task 21); everyone else (LOCATION_ADMIN/ORG_ADMIN/
// SUPER_ADMIN, who all reach /calendar per Layout's nav item) gets the
// admin view (Task 20), which already handles its own location/org scoping
// internally. A future PARENT calendar (Task 22) would extend this same
// branch rather than adding a fourth URL.
import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import AdminCalendar from './AdminCalendar';
import StaffCalendar from './StaffCalendar';

const CalendarRoute: React.FC = () => {
  const { isStaff } = useAuth();
  return isStaff ? <StaffCalendar /> : <AdminCalendar />;
};

export default CalendarRoute;
